module.exports = __webpack_public_path__ + "static/img/logo1.255a850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo1.png
// module id = 6Yvq
// module chunks = 37